import React, { useEffect } from 'react';
import { FaCheck, FaInfo, FaExclamation } from 'react-icons/fa';

interface ToastProps {
  message: string;
  type?: 'success' | 'info' | 'error';
  onClose: () => void;
}

const Toast: React.FC<ToastProps> = ({ message, type = 'success', onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 3000);

    return () => clearTimeout(timer);
  }, [onClose]);

  const icons = {
    success: <FaCheck className="text-green-500" />,
    info: <FaInfo className="text-blue-500" />,
    error: <FaExclamation className="text-red-500" />
  };

  return (
    <div className="fixed bottom-4 left-1/2 transform -translate-x-1/2 z-[99999] animate-fade-in">
      <div className="flex items-center space-x-2 bg-gray-800 text-white px-4 py-2 rounded-lg shadow-lg border border-gray-700">
        <div className="flex-shrink-0">
          {icons[type]}
        </div>
        <p className="text-sm">{message}</p>
      </div>
    </div>
  );
};

export default Toast; 